import { CopyToClipboardButton } from "@octopusdeploy/design-system-components";
import type React from "react";
import styles from "./style.module.less";
interface CopyValueToClipboardProps {
    value: string;
    children?: React.ReactNode;
}
const CopyValueToClipboard: React.FC<CopyValueToClipboardProps> = ({ value, children }) => {
    return (<div className={styles.copyValue}>
            {children ? children : <strong>{value}</strong>}
            <CopyToClipboardButton value={value}/>
        </div>);
};
CopyValueToClipboard.displayName = "CopyValueToClipboard"
export default CopyValueToClipboard;
